import { useEffect, useState } from "react";
import { Bell, ExternalLink, X } from "lucide-react";
import { collection, doc, limit, onSnapshot, orderBy, query, serverTimestamp, updateDoc, type Timestamp } from "firebase/firestore";
import { db } from "./firebase";

interface AppNotification {
  id: string;
  title: string;
  body: string;
  status: string;
  createdAt?: Timestamp;
  target?: { section?: string; briefId?: string; memoryId?: string };
}

export function NotificationCenter({ userId, onOpenBrief, onOpenMemory }: { userId: string; onOpenBrief: (briefId: string) => void; onOpenMemory: (memoryId: string) => void }) {
  const [records, setRecords] = useState<AppNotification[]>([]);
  useEffect(() => onSnapshot(query(collection(db, "users", userId, "notifications"), orderBy("createdAt", "desc"), limit(10)), (snapshot) => {
    setRecords(snapshot.docs.map((item) => ({ id: item.id, ...item.data() } as AppNotification)).filter((item) => item.status === "unread"));
  }), [userId]);
  const current = records[0];
  if (!current) return null;

  const markRead = () => updateDoc(doc(db, "users", userId, "notifications", current.id), { status: "read", readAt: serverTimestamp(), updatedAt: serverTimestamp() });
  const open = async () => {
    const briefId = current.target?.briefId;
    const memoryId = current.target?.memoryId;
    await markRead().catch(() => undefined);
    if (briefId) onOpenBrief(briefId);
    else if (memoryId) onOpenMemory(memoryId);
  };

  return <aside className="app-notification" role="status" aria-live="polite">
    <Bell size={18} />
    <div><strong>{current.title || "Executive Second Brain"}</strong><span>{current.body || "Your brief is ready."}</span></div>
    {(current.target?.briefId || current.target?.memoryId) && <button onClick={() => void open()}><ExternalLink size={14} />Open</button>}
    <button className="icon-button" title="Dismiss" aria-label="Dismiss notification" onClick={() => void markRead()}><X size={15} /></button>
  </aside>;
}
